module.exports = __webpack_public_path__ + "img/wifi-fair.60f016c7.svg";